export class AbortedError extends DOMException {
    public constructor(public signal?: AbortSignal) {
        super('Action aborted');

        Object.setPrototypeOf(this, AbortedError.prototype);
    }
}
